import React from 'react';
import RootStore from './RootStore';

const rootStore = new RootStore();

export const StoreContext = React.createContext<RootStore | null>(null);

export function useRootStore() {
  const ctx = React.useContext(StoreContext);
  if (ctx === null) {
    throw Error('"useRootStore must be used within a "StoreContextProvider"');
  }
  return ctx;
}

interface Props {}
type StoreContextProviderProps = React.PropsWithChildren<Props>;

function StoreContextProvider({ children }: StoreContextProviderProps) {  
  return (
    <StoreContext.Provider value={rootStore}>
      {children}
    </StoreContext.Provider>
  );
}
export default StoreContextProvider;